import { useCallback, useContext } from 'react';
import { Url } from '@wix/da-url';
import {
  pushGlobalConfirmationModal,
  GlobalConfirmationPopupProps,
} from '../../Modals/redux/actionCreators';
import { useAction } from '@wix/da-hooks/pkg/useAction';
import { SessionContext } from '@wix/da-react-context/pkg/publicSession';

export function useRestrictedToCore<T extends (...args: any[]) => void>(
  action: T,
  referer?: string,
  params?: Partial<GlobalConfirmationPopupProps>
): T {
  const { hasCoreMembership } = useContext(SessionContext);
  const dispatchPushGlobalConfirmationModal = useAction(
    pushGlobalConfirmationModal
  );

  const handleAction = useCallback(
    (...args: any[]) => {
      if (hasCoreMembership) {
        action(...args);
      } else {
        dispatchPushGlobalConfirmationModal({
          titleTransKey: 'coreUpsellModal.title',
          textTransKey: 'coreUpsellModal.text',
          confirmBtnLabelTransKey: 'common.upgradeCoreCTA',
          cancelBtnLabelTransKey: 'common.cancel',
          confirmBtnType: 'core',
          icon: (
            <img
              alt=""
              src="https://st.deviantart.net/eclipse/illustrations/il2.15_core_ball_pixel.png"
              width="90px"
              height="88px"
            />
          ),
          ...params,
          onConfirm: () => {
            window.location.href = Url.coreMembershipLink({ referer });
          },
        } as GlobalConfirmationPopupProps);
      }
    },
    [
      dispatchPushGlobalConfirmationModal,
      referer,
      action,
      hasCoreMembership,
      params,
    ]
  );

  return handleAction as T;
}
